
import './App.css';
import { NavbarLink } from './component/navbar';


function App() {
  return (
    <div className="App">
    <NavbarLink/>
    </div>
  );
}

export default App;
